import script from "./ConfigurationPackageInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationPackageInformation.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationPackageInformation.vue?vue&type=style&index=0&id=2b1b39af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b1b39af"]])

export default __exports__